// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2sM5R","rightAdornment":"Header_rightAdornment__1rlb1"};